var _circle, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXpanstechMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 1 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 29,
    r: 28,
    fill: "url(#xpanstechMark)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6779 29.5347C25.9105 28.3834 25.8851 27.2383 26.1438 26.0258C27.1979 21.0469 30.7084 15.0274 36.2866 15.311C40.0612 15.5068 42.0118 11.0313 39.5993 8.34466C37.1784 5.66271 32.5267 7.14468 32.3362 10.9306C32.0435 16.5023 25.6923 19.3791 20.6284 19.919C19.3922 20.0513 18.2678 19.9014 17.0928 20.0183C10.4558 20.6541 7.6383 28.5473 11.9308 33.3082C16.2233 38.0684 24.3678 36.07 25.6779 29.5347Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2686 36.4373C18.4376 36.5515 19.5742 36.4097 20.8068 36.5437C25.867 37.0858 32.2125 39.9657 32.4978 45.5439C32.687 49.3188 37.3377 50.804 39.765 48.1306C42.1868 45.4494 40.2393 40.9726 36.4536 41.1683C30.881 41.4439 27.373 35.4184 26.3208 30.4356C26.0634 29.2193 26.0981 28.0855 25.8623 26.9285C24.5546 20.3907 16.4157 18.3908 12.1162 23.1454C7.81743 27.8999 10.6339 35.7987 17.2686 36.4373Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6352 8.191C18.3726 8.62299 18.2135 9.08078 17.9298 9.53382C16.7742 11.3839 14.4704 13.2892 12.2654 12.3507C10.7738 11.7153 9.32777 13.2276 9.90848 14.6669C10.4821 16.1 12.5771 16.1946 13.2145 14.7022C14.1517 12.4986 17.1337 12.2806 19.2472 12.808C19.7637 12.9377 20.199 13.1611 20.689 13.2895C23.4542 14.0144 25.7573 11.2533 24.7293 8.69913C23.703 6.15028 20.131 5.75385 18.6352 8.191Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8446 43.357C20.3527 43.4735 19.915 43.6817 19.3933 43.7979C17.2647 44.2746 14.2903 43.9727 13.4099 41.7439C12.8147 40.2358 10.7225 40.2686 10.1057 41.6928C9.48846 43.1076 10.8924 44.6654 12.4024 44.0711C14.6293 43.1906 16.8788 45.1603 17.9877 47.0352C18.2581 47.494 18.4048 47.9608 18.6575 48.3998C20.0835 50.8773 23.6666 50.5777 24.7629 48.0521C25.8565 45.5314 23.63 42.7102 20.8446 43.357Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1316 29.5243C35.7974 29.6292 36.4515 29.583 37.1501 29.6877C40.0238 30.1462 43.5684 31.9786 43.5684 35.1641C43.5684 37.3333 46.1794 38.3156 47.6446 36.8509C49.1035 35.3916 48.1223 32.781 45.9556 32.781C42.7605 32.781 40.9322 29.2334 40.4769 26.3613C40.3673 25.6638 40.415 25.007 40.3173 24.3444C39.7581 20.5707 35.1651 19.1869 32.5711 21.7852C29.9798 24.3738 31.3607 28.9724 35.1316 29.5243Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "xpanstechMark",
    x1: 28,
    y1: 1,
    x2: 28,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25BEC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165D59"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpanstechMark);
export default __webpack_public_path__ + "static/media/xpanstech-mark.503a7071396bf5d078bc20b3672a725d.svg";
export { ForwardRef as ReactComponent };